import { createAction } from 'redux-actions'

export const onAppMounted = createAction('ON_APP_MOUNTED')
